<template>
  <div class="flex">
    <AdminPanel :key="thisKey">
      <h1 class="mb-4">Pricing Per Color</h1>
      <div :key="tier" v-for="tier in Object.keys(tiers)">
        <div class="mt-4">
          <h2>{{ tier }}</h2>
        </div>
        <div :key="qtyPricing.id" v-for="(qtyPricing, index) in tiers[tier]" class="mt-4 flex flex-col items-center">
          <div class="flex-1 text-center">
            {{ index > 0 ? tiers[tier][index - 1].maxQty + 1  : 12 }} - {{ qtyPricing.maxQty }} <br>shirts
          </div>
          <div :key="`${qtyPricing.id}-${numColors}`" v-for="numColors in [1,2,3,4,5,6]" class="flex justify-around items-center">
            <div class="mr-4">
              {{ numColors }} Color{{ numColors > 1 ? 's' : ' ' }}
            </div>
            <MoneyInput :ref="`${qtyPricing.id}-${numColors}`" :tier="tier" :initValue="qtyPricing.sidePrices[numColors]"></MoneyInput>
          </div>
        </div>
      </div>
      <div class="mt-4" @click="save">
        <JButton :label="saveText" :isWhite="false"></JButton>
      </div>
    </AdminPanel>
  </div>
</template>

<script>
import AdminPanel from '@/components/AdminPanel'
import JButton from '@/components/JButton'
import MoneyInput from '@/components/MoneyInput'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  name: 'ChangeSidePricing',
  components: { MoneyInput, JButton, AdminPanel },
  data () {
    return {
      saveText: 'Save',
      tiers: {},
      thisKey: 0
    }
  },
  async mounted () {
    if (Object.keys(this.tiers).length === 0) {
      const tierNames = ['tier1', 'tier2', 'tier3']
      for (let tierName of tierNames) {
        this.tiers[tierName] = []
        const tierData = (await firebase.firestore().collection(`pricing/colors/${tierName}`).get())
        tierData.forEach(pricingCollection => {
          const docId = pricingCollection.id
          const pricingDataForTier = pricingCollection.data()
          const priceForQty = {
            id: docId,
            sidePrices: {}
          }
          priceForQty.maxQty = pricingDataForTier.maxQty

          for (let numSides of Object.keys(pricingDataForTier.sidePrices)) {
            priceForQty.sidePrices[numSides] = pricingDataForTier.sidePrices[numSides]
          }

          this.tiers[tierName].push(priceForQty)
        })
      }

      Object.keys(this.tiers).forEach(tier => {
        this.tiers[tier] = this.tiers[tier].sort((a, b) => a.maxQty - b.maxQty)
      })
    }

    this.thisKey++

    return this.tiers
  },
  methods: {
    async getTierPricing () {

    },
    async save () {
      this.saveText = 'Saving...'
      for (let moneyInputDocIdWithNumColors of Object.keys(this.$refs)) {
        const refSplit = moneyInputDocIdWithNumColors.split('-')
        const docId = refSplit[0]
        const numColors = refSplit[1]
        const moneyInput = this.$refs[moneyInputDocIdWithNumColors][0]
        const tier = moneyInput.getTier()
        const value = moneyInput.getValue()
        const originalPricing = this.tiers[tier].find(priceDoc => priceDoc.id === docId)
        if (originalPricing.sidePrices[numColors] !== undefined && originalPricing.sidePrices[numColors] !== value) {
          const newSidePrices = originalPricing.sidePrices
          newSidePrices[numColors] = value
          await firebase.firestore().doc(`pricing/colors/${tier}/${docId}`).update({ sidePrices: newSidePrices })
        }
      }
      this.saveText = 'Saved!'
    }
  }
}
</script>
